import Typography from "../reusable/Typography/Typography"
import FilterDropdownItem from "./dropdown/FilterDropdownItem"
import {CollectionName} from "../../constants"
import React, {useContext, useEffect, useState} from "react"
import DataContext from "../../context/DataContext"
import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import {EBIKES_SUBCATEGORIES, FilterMobileTabsSlugsList, VELOS_SUBCATEGORIES} from "../../constants/TopCategories"
import {filterUrl} from "./FilterUrl"
import urlParams from "../../utility/UrlParams"
import FilterModalButtonMobile from "./filterModalMobile/FilterModalButtonMobile"

const quickDeliveryCategory = {
	title: "quick-delivery",
	buttonTitle: "",
	slugName: "instock"
}

type Props = {
	collectionName: CollectionName
	filters: any
    handleOpen?: () => void;
}

const FilterbarMobileTabs: React.FC<Props> = ({collectionName, filters, handleOpen}) => {
	const router = useRouter()
	const {locale, query} = router
	const {t} = useTranslation(["common", "filters"])
	const [activeTitle, setActiveTitle] = useState(FilterMobileTabsSlugsList[locale][0].title)
	const {accessoryFilters, brandWorld} = useContext(DataContext)
	const categories = filters?.[0]

	const accessoriesTypes = accessoryFilters?.[0]

	const isBrandWorld = router.pathname?.includes("/brand-world")
	useEffect(() => {
		if (!query?.categories) {
			setActiveTitle("Alle Modelle")
			return
		}

		const category = Array.isArray(query.categories) ? query?.categories[0] : query?.categories
		if (VELOS_SUBCATEGORIES.includes(category)) {
			setActiveTitle("Velos")
			return
		}

		if (EBIKES_SUBCATEGORIES.includes(category)) {
			setActiveTitle("E-Bikes")
			return
		}

		const matchedCategory = FilterMobileTabsSlugsList[locale]?.find(category =>
			category.itemsList?.some(item => item.slugName === query.categories)
		)

		if (matchedCategory) {
			setActiveTitle(matchedCategory.title)
		}
	}, [query?.categories, locale])

	const handleMainCategoryClick = (e, category) => {
		e.preventDefault()
		const isActive = activeTitle === category.title

		if (isActive) {
			setActiveTitle("Alle Modelle")
			router.push(
				filterUrl({}, urlParams.categories, null),
				null,
				{shallow: true}
			)
			return
		}

		setActiveTitle(category.title)
		router.push(
			category.title === "Accessories" ?
				category.slugName :
				isBrandWorld ?
					router.push(
						`${filterUrl(
							{[urlParams.categories]: category.slugName},
							urlParams.categories,
							category.slugName,
							CollectionName.BrandWorld,
							CollectionName.BrandWorld,
							brandWorld.brandSlug
						)}#products-listing`,
						null,
						{shallow: true}
					) :
					filterUrl({[urlParams.categories]: category.slugName}, null, null),
			null,
			{shallow: true}
		)
	}

	return (
		<div className="pt-2 ps-1">
			{collectionName === CollectionName.Accessories ?
				<div className="px-2 mb-4 d-flex align-items-center gap-2">
					<div>
						<FilterModalButtonMobile openModal={handleOpen}/>
					</div>
					<div className={"px-0 d-md-flex accessories-tabs justify-content-center"}
						style={{width: "100%", overflowX: "scroll"}}>
						<ul className="px-0 d-flex align-items-center list-unstyled bike-categories ms-2"
							style={{height: 48}}>
							{categories?.options?.map((category, idx) => {
								return <div key={idx}
									className="col-auto">
									<FilterDropdownItem key={category}
										isBoxShape={true}
										label={category.name}
										collectionName={collectionName}
										param={categories.slug}
										value={category.slug}/>
								</div>
							}
							)}
						</ul>
					</div>
				</div> :
				<>
					<div className="px-2 d-flex align-items-center gap-2">
						<div>
							<FilterModalButtonMobile openModal={handleOpen}/>
						</div>
						<div className="px-md-0 d-md-flex justify-content-center bike-types mb-md-2 main-cats"
							style={{width: "100%", overflowX: "scroll"}}>
							<ul className="px-0 mb-0 d-flex align-items-center list-unstyled bikes-tabs scrollbar-hide"
								style={{height: 36, overflowX: "scroll"}}>
								{FilterMobileTabsSlugsList[locale]?.map((category, idx) => (
									<li key={idx}
										className={`${(activeTitle === category.title) ? "bike-tab-active" : ""} 
                                    px-3 bike-tab d-flex align-items-center bike-tab`}
										onClick={e => handleMainCategoryClick(e, category)}>
										<Typography
											variant={
												(activeTitle === category.title) ? "bodyLgBold" : "bodyLg"}
											className={"text-nowrap"}>
											{category.title}
										</Typography>
									</li>

								))}
							</ul>
						</div>
					</div>
					<div className={"px-0 mb-2 mt-3 pb-2 d-md-flex justify-content-center"}
						style={{width: "100%", overflowX: "scroll"}}>
						<ul className="px-0 d-flex align-items-center list-unstyled bike-categories ms-2"
							style={{height: 48}}>
							{activeTitle === "Alle produkte" ?
								<>
									<div className="col-auto px-0 d-flex align-items-center gy-2"
										style={{maxHeight: 40}}>
										<FilterDropdownItem
											key={quickDeliveryCategory.title}
											isBoxShape={true}
											label={t(quickDeliveryCategory.title)}
											param={"verfugbar"}
											value={quickDeliveryCategory.slugName}
											collectionName={collectionName}
										/>
									</div>
									{FilterMobileTabsSlugsList[locale]?.find(category => category.title === activeTitle)?.itemsList?.map((item, idx) => (
										<li key={idx}
											className="col-auto">
											<FilterDropdownItem
												key={item.title}
												isBoxShape={true}
												label={item.title}
												collectionName={collectionName}
												param={"categories"}
												value={item.slugName}
											/>
										</li>
									))}
									{accessoriesTypes?.options?.map((item, idx) => (
										<li key={idx}
											className="col-auto">
											<FilterDropdownItem
												key={item}
												isBoxShape={true}
												label={item.name}
												collectionName={CollectionName.Accessories}
												param={accessoriesTypes.slug}
												value={item.slug}
											/>
										</li>
									))}
								</> :
								activeTitle === "Accessories" ?
									accessoriesTypes?.options?.map((item, idx) => (
										<li key={idx}
											className="col-auto">
											<FilterDropdownItem
												key={item}
												isBoxShape={true}
												label={item.name}
												collectionName={CollectionName.Accessories}
												param={item.slug}
												value={item.slug}
											/>
										</li>
									)) :
									FilterMobileTabsSlugsList[locale]?.find(category => category.title === activeTitle)?.itemsList?.map((item, idx) => (
										<li key={idx}
											className="col-auto">
											<FilterDropdownItem
												key={item}
												isBoxShape={true}
												label={item.title}
												collectionName={collectionName}
												param={"categories"}
												value={item.slugName}
											/>
										</li>
									))}
						</ul>
					</div>
				</>
			}
		</div>
	)
}

export default FilterbarMobileTabs
